exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quizDisplay{margin-bottom:30px}.quizDisplay .innerAnswer,.quizDisplay .innerAnswer .commentBox{margin-bottom:20px}.quizDisplay .answerIndex0 .controlBox{padding-top:10px}.quizDisplay .answerIndex0 .withUpperControl .controlBox{border-top:1px solid #ddd;border-top-left-radius:5px;padding-bottom:10px}.quizDisplay.controlModeEdit .controlBox{visibility:hidden}.quizDisplay.controlModeEdit .answerIndex0 .withUpperControl .controlBox{visibility:visible;border-bottom:1px solid #ddd;border-bottom-left-radius:5px;position:absolute;right:0;z-index:2}.quizDisplay .answerLastIndex .answerText{margin-bottom:0}.quizDisplay .answerLastIndex .withUpperControl .controlBox{border-bottom:1px solid #ddd;border-bottom-left-radius:5px}.quizDisplay .revisionButton{margin-right:10px}.quizDisplay .displayContainer{display:flex;flex-direction:row;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/quizzes/quiz_display.scss
// module id = 1497
// module chunks = 0